import React from "react";

import { ScrollView } from "devextreme-react/scroll-view";

// import {
//   createHtmlPortalNode,
//   InPortal,
//   OutPortal,
// } from 'react-reverse-portal';
import { Case, CaseElse, Switch, useWindowDimensions } from "@app/contexts";
import { SPV_CONTRACTOR_MIRROR } from "@app/state/constants";
import { useFxSelector } from "@app/statefx";
import { selectCurrentMirroredTab } from "@app/statefx/selectors/uiSpvMainContractor.sel";

import "../invoiceSPV/invoices.scss";
import { ContractorForm } from "./contractorForm";

import type { FormRef } from "devextreme-react/form";
export const ContractorFormGroup = () => {
  const mainFormRef = React.useRef<FormRef>(null);
  const mirroredFormTemp = React.useRef<FormRef>(null);
  const mirroredFormAnaf = React.useRef<FormRef>(null);
  const mirroredFormInDB = React.useRef<FormRef>(null);
  const mirrorForm = useFxSelector(selectCurrentMirroredTab);

  // const ContractorCFFPortal = useMemo(() => createHtmlPortalNode(), []);
  // const ContractorTMPPortal = useMemo(() => createHtmlPortalNode(), []);
  // const ContractorANAFPortal = useMemo(() => createHtmlPortalNode(), []);
  // const ContractorInDBPortal = useMemo(() => createHtmlPortalNode(), []);

  const { height: fullHeight, headersFooters } = useWindowDimensions();
  return (
    <React.Fragment>
      {/* <InPortal node={ContractorCFFPortal}>
        <ContractorForm key={'a'} source="CFF_MAIN" frmConRef={mainFormRef} />
      </InPortal>
      <InPortal node={ContractorTMPPortal}>
        <ContractorForm
          key={'b'}
          source={'CFF_TMP'}
          frmConRef={mirroredFormTemp}
          mainConRef={mainFormRef}
        />
      </InPortal>
      <InPortal node={ContractorANAFPortal}>
        <ContractorForm
          key={'c'}
          source="ANAF"
          frmConRef={mirroredFormAnaf}
          mainConRef={mainFormRef}
        />
      </InPortal>
      <InPortal node={ContractorInDBPortal}>
        <ContractorForm
          key={'d'}
          source="CONTACTE"
          frmConRef={mirroredFormInDB}
          mainConRef={mainFormRef}
        />
      </InPortal> */}
      <ScrollView height={fullHeight - (headersFooters + 60)}>
        <div id="contractor-in-mirror">
          <div className="contractor-cff">
            {/* <OutPortal node={ContractorCFFPortal} /> */}
            <ContractorForm
              key={"a"}
              source="CFF_MAIN"
              frmConRef={mainFormRef}
            />
          </div>
          <Switch value={mirrorForm}>
            <Case when={SPV_CONTRACTOR_MIRROR.CTR_MIRR_TMP}>
              <div className="contractor-tmp">
                {/* <OutPortal node={ContractorTMPPortal} /> */}
                <ContractorForm
                  key={"b"}
                  source={"CFF_TMP"}
                  frmConRef={mirroredFormTemp}
                  mainConRef={mainFormRef}
                />
              </div>
            </Case>
            <Case when={SPV_CONTRACTOR_MIRROR.CTR_MIRR_ANAF}>
              <div className="contractor-tmp">
                {/* <OutPortal node={ContractorANAFPortal} /> */}
                <ContractorForm
                  key={"c"}
                  source="ANAF"
                  frmConRef={mirroredFormAnaf}
                  mainConRef={mainFormRef}
                />
              </div>
            </Case>
            <Case when={SPV_CONTRACTOR_MIRROR.CTR_MIRR_ARCHIVE}>
              <div className="contractor-tmp">
                {/* <OutPortal node={ContractorInDBPortal} /> */}
                <ContractorForm
                  key={"d"}
                  source="CONTACTE"
                  frmConRef={mirroredFormInDB}
                  mainConRef={mainFormRef}
                />
              </div>
            </Case>
            <CaseElse>
              <div className="contractor-tmp">
                <div>Contractor</div>
              </div>
            </CaseElse>
          </Switch>
        </div>
      </ScrollView>
    </React.Fragment>
  );
};
